<template>
  <SeoPage page-key="sviluppoSoftwarePersonalizzatiTicino" />
</template>

<script setup>
import SeoPage from '../components/SeoPage.vue'

defineOptions({
  name: 'SviluppoSoftwarePersonalizzatiTicinoPage'
})
</script>

